export default __webpack_public_path__ + "static/media/1.937fb0d9.png";